// extracted by mini-css-extract-plugin
export var eraseButton = "survey-module--erase-button--nWiEm";
export var form = "survey-module--form--6o7TW";
export var globalErrors = "survey-module--global-errors--B27Vb";
export var preview = "survey-module--preview--243PA";
export var stepsContainer = "survey-module--steps-container--chJDu";
export var submitContainer = "survey-module--submit-container--Z22Lz";
export var successBox = "survey-module--success-box--l8Orb";
export var survey = "survey-module--survey--Ay8fN";